import React, { useState } from "react";
import Draggable from "react-draggable";

import CreateWithNovaAiModalHeader from "./CreateWithNovaAiModalHeader";
import CreateWithNovaAiModalBody from "./CreateWithNovaAiModalBody";
import CreateWithNovaAiModalFooter from "./CreateWithNovaAiModalFooter";
import NovaChatHistoryHeader from "./NovaChatHistoryHeader";
import "./Nova.scss";

import useNovaAiModal from "./hooks/useNovaAiModal";
import { useTranslation } from "react-i18next";

const CreateWithNovaAiModal = (props) => {
  const { isNovaChatBotOpen } = props;
  const { i18n } = useTranslation();
  const dir = i18n.dir();

  const { propsForNovaAi } = useNovaAiModal(props);
  const {
    setDisabled,
    draggleRef,
    showHistory,
    handleClose,
    handleBackToChat,
  } = propsForNovaAi;

  const [isDraggedToEdge, setIsDraggedToEdge] = useState(false);

  const handleDrag = (e, data) => {
    const threshold = 0.5 * window.innerWidth;

    if (dir === "rtl") {
      // In RTL, dragged towards the right edge
      const isRight = data.x >= threshold;
      setIsDraggedToEdge(isRight);
    } else {
      // In LTR, dragged towards the left edge
      const isLeft = data.x <= -threshold;
      setIsDraggedToEdge(isLeft);
    }
  };

  if (!isNovaChatBotOpen) return null;

  return (
    <div
      className={
        dir === "rtl" ? "custom-modal-overlay-rtl" : "custom-modal-overlay"
      }
    >
      <Draggable
        axis="x"
        handle=".draggable-handle"
        bounds="parent"
        onDrag={handleDrag}
      >
        <div
          className="create-with-nova-ai-modal custom-modal"
          ref={draggleRef}
        >
          <div className="nova-ai-modal-header">
            {showHistory ? (
              <NovaChatHistoryHeader
                onBack={handleBackToChat}
                onClose={handleClose}
                setDisabled={setDisabled}
              />
            ) : (
              <CreateWithNovaAiModalHeader {...propsForNovaAi} {...props} />
            )}
          </div>

          <CreateWithNovaAiModalBody
            {...propsForNovaAi}
            {...props}
            isDraggedToEdge={isDraggedToEdge}
            dir={dir}
          />

          {!showHistory && (
            <CreateWithNovaAiModalFooter {...propsForNovaAi} {...props} />
          )}
        </div>
      </Draggable>
    </div>
  );
};

export default CreateWithNovaAiModal;
